// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1v1gJ","productName":"Table_productName__3tGAs"};